import { __assign, __rest, __spreadArray } from "tslib";
import React, { useCallback } from 'react';
import { RemoveCircleOutline as RemoveCircleIcon } from '@mui/icons-material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { FilterIcon } from 'components';
var useCustomSectionForm = function (_a, hasCustomerProfileFilter, setSections) {
    var endIndexIgnoredForRemoval = _a.endIndexIgnoredForRemoval, headerParams = _a.header, itemsParams = _a.items, maxItems = _a.maxItems, prefix = _a.prefix, sectionsIndex = _a.sectionsIndex, getNewItemModel = _a.getNewItemModel;
    var control = useFormContext().control;
    var _b = useFieldArray({
        control: control,
        name: prefix
    }), append = _b.append, remove = _b.remove, swap = _b.swap;
    var getUpdatedSections = useCallback(function (sections, itemsLength, items) {
        var sectionsCopy = sections.slice();
        var header = sections[sectionsIndex].header;
        sectionsCopy.splice(1, 1, {
            header: __assign(__assign({}, header), { actionProps: __assign(__assign({}, header.actionProps), { disabled: maxItems && itemsLength >= maxItems }) }),
            items: items
        });
        return sectionsCopy;
    }, [maxItems, sectionsIndex]);
    var focusInput = function (name) {
        setTimeout(function () {
            var input = document.querySelector("[name=\"".concat(name, "\"]"));
            input.focus();
        });
    };
    var removeItem = useCallback(function (name) { return function () {
        setSections(function (sections) {
            var items = sections[1].items;
            var itemsLength = items.length;
            var newItems = [];
            var getCustomItemLabel = itemsParams.getCustomItemLabel, getCustomItemName = itemsParams.getCustomItemName;
            var foundIndex = -1;
            for (var index = 0; index < itemsLength; index += 1) {
                var item = items[index];
                var inputPropsName = item.inputProps.name;
                if (foundIndex > 0) {
                    item.inputProps.label = getCustomItemLabel(index - 1);
                    item.inputProps.name = getCustomItemName(index - 1);
                    swap(index, index - 1);
                }
                if (name === inputPropsName)
                    foundIndex = index;
                else
                    newItems.push(item);
            }
            remove(itemsLength - 1);
            focusInput(getCustomItemName(foundIndex - 1));
            return getUpdatedSections(sections, itemsLength - 1, newItems);
        });
    }; }, [itemsParams, getUpdatedSections, setSections, remove, swap]);
    var getNewCustomItem = useCallback(function (index, item) {
        var inputProps = itemsParams.inputProps, xs = itemsParams.xs, getCustomItemLabel = itemsParams.getCustomItemLabel, getCustomItemName = itemsParams.getCustomItemName, _a = itemsParams.getHasFilter, getHasFilter = _a === void 0 ? function () { return undefined; } : _a, getRequired = itemsParams.getRequired;
        var _b = inputProps || {}, InputProps = _b.InputProps, otherInputProps = __rest(_b, ["InputProps"]);
        return __assign(__assign({ formType: 'textField' }, (endIndexIgnoredForRemoval !== undefined &&
            index > endIndexIgnoredForRemoval
            ? {
                actionProps: {
                    Icon: RemoveCircleIcon,
                    execute: removeItem
                }
            }
            : {})), { inputProps: __assign(__assign({ hasEndCopyIcon: true, label: getCustomItemLabel(index, item), name: getCustomItemName(index), variant: 'standard' }, (getRequired ? { required: getRequired(index) } : {})), __assign(__assign({}, otherInputProps), { InputProps: __assign(__assign({}, InputProps), (hasCustomerProfileFilter && getHasFilter(index)
                    ? {
                        endAdornment: React.createElement(FilterIcon, null)
                    }
                    : {})) })), xs: xs });
    }, [
        endIndexIgnoredForRemoval,
        hasCustomerProfileFilter,
        itemsParams,
        removeItem
    ]);
    var getCustomItems = useCallback(function (items) {
        return items.map(function (item, index) { return getNewCustomItem(index, item); });
    }, [getNewCustomItem]);
    var addItem = useCallback(function () {
        append(getNewItemModel());
        setSections(function (sections) {
            var items = sections[1].items;
            var itemsLength = items.length;
            var newItem = getNewCustomItem(itemsLength);
            focusInput(newItem.inputProps.name);
            return getUpdatedSections(sections, itemsLength + 1, __spreadArray(__spreadArray([], items, true), [newItem], false));
        });
    }, [
        append,
        getNewCustomItem,
        getNewItemModel,
        getUpdatedSections,
        setSections
    ]);
    var getCustomSection = useCallback(function (items) {
        var newSection = {
            header: __assign(__assign({}, headerParams), { actionProps: __assign(__assign({}, headerParams.actionProps), { execute: addItem }) }),
            items: getCustomItems(items)
        };
        return newSection;
    }, [headerParams, addItem, getCustomItems]);
    return { getCustomSection: getCustomSection };
};
export default useCustomSectionForm;
//# sourceMappingURL=useCustomSectionForm.js.map